import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { browserHistory, Link, withRouter } from 'react-router';
import ShowAdmins from '../components/admins/ShowAdmins';
import { clearAuthErrors, fetchAdmins, clearAdminsErrors } from '../actions';
import autoBind from 'react-autobind';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import baseTheme from 'material-ui/styles/baseThemes/lightBaseTheme';
import RaisedButton from 'material-ui/RaisedButton';
import Pagination from '../components/home/Pagination';
import TextField from 'material-ui/TextField';
import { cyan900 } from 'material-ui/styles/colors';

const propTypes = {
  dispatch: PropTypes.func.isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
  admins: PropTypes.object.isRequired,
  query: PropTypes.object.isRequired,
  router: PropTypes.object,
};

class AdminsPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      admins: props.admins,
    };
    autoBind(this);
  }
  getChildContext() {
    return { muiTheme: getMuiTheme(baseTheme) };
  }
  componentWillMount() {
    // TODO : fix authentication - Gabo
    if (!this.props.isAuthenticated) {
      this.props.dispatch(clearAuthErrors());
      browserHistory.goBack();
    }
    this.props.dispatch(clearAdminsErrors());
    const query = this.props.query;
    const router = this.props.router;
    if (this.props.admins.search && this.props.admins.search.length > 0) {
      query.search = this.props.admins.search;
    }
    if (!query.page) {
      query.page = 1;
      router.push({ pathname: '/admins', query });
    } else {
      this.props.dispatch(fetchAdmins(query));
    }
  }
  handleSearchChange(e) {
    const admins = this.props.admins;
    const query = this.props.query;
    const router = this.props.router;
    const nextAdminsInput = e.target.value;
    const nextAdmins = (nextAdminsInput !== '') ? nextAdminsInput : '';
    admins.search = nextAdmins;
    this.setState({
      admins,
    });
    if (nextAdmins.length > 0) {
      query.search = nextAdmins;
    } else {
      delete query.search;
    }
    query.page = 1;
    router.push({ pathname: '/admins', query });
    this.props.dispatch(fetchAdmins(query));
  }
  navigation(route) {
    this.props.dispatch(fetchAdmins(route));
  }
  render() {
    const styles = {
      floatingLabelStyle: {
        color: cyan900,
      },
      inputStyle: {
        marginRight: '1%',
      },
    };
    const authPage = {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
    };
    return (
      <div className="admins component" style={authPage}>
        <h2>Admins</h2>
        <div className="content">
          <div className="action-buttons">
            <Link to={'/admins/new'}>
              <RaisedButton
                label="Add new Admin"
                primary
              />
            </Link>
          </div>
          <div className="action-buttons top">
            <TextField
              floatingLabelText="Search by Name/Email"
              floatingLabelStyle={styles.floatingLabelStyle}
              inputStyle={styles.inputStyle}
              value={this.props.admins.search}
              onChange={this.handleSearchChange}
            />
            <Pagination
              paginationInfo={this.props.admins.meta}
              pageCall={route => this.navigation(route)}
            />
          </div>
          <hr />
          <ShowAdmins
            adminsList={this.props.admins}
          />
        </div>
        <div className="action-buttons bottom">
          <Pagination
            paginationInfo={this.props.admins.meta}
            pageCall={route => this.navigation(route)}
          />
        </div>
      </div>
    );
  }
}

AdminsPage.childContextTypes = {
  muiTheme: PropTypes.object.isRequired,
};

AdminsPage.propTypes = propTypes;

function mapStateToProps(state, ownProps) {
  return {
    isAuthenticated: state.auth.isAuthenticated,
    admins: state.admins,
    query: ownProps.location.query,
  };
}

export default withRouter(connect(mapStateToProps)(AdminsPage));



// WEBPACK FOOTER //
// ./src/containers/AdminsPage.js